import {
	Select, Modal, Checkbox, Form, Input
}from 'antd'
import {
	useEffect
}from 'react'
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	rePriceFormationOrderActions
}from '../NRI/RePriceFormationOrder/store/actions'
import {
	Scrollbars
}from "react-custom-scrollbars"
import CustomButton from '../../components/CustomButton'
import CustomSelect from '../../components/CustomSelect'
import './style.css'
import {
	reInfoOrgTypeActions
}from '../NRI/ReInfoOrgType/store/actions'

const { Option } = Select

const ChangeReInfoOrg = ({ visible, setVisible, record, setRecord, update, prices, types }) => {
	const [form] = Form.useForm()
	const { changed, isSending } = useSelector(state => state.reInfoOrgReducer)
	const dispatch = useDispatch()

	useEffect(() => {
		return () => {
			dispatch(reInfoOrgTypeActions.clear())
			dispatch(rePriceFormationOrderActions.clear())
		}
	}, [])

	useEffect(() => {
		if (record){
			form.setFieldsValue({
				priceOrders         : record.prices.map(pr => pr.id),
				isUsePossibleRegion : record.isUsePossibleRegion,
				reOrg               : record.fullName,
				type                : record.typeId ?? undefined
			})
		}
	}, [record])

	 useEffect(() => {
		if (changed)
	 		handleCancel()
	 }, [changed])

	const handleCancel = () => {
		setVisible(false)
		setRecord(null)
		form.resetFields()
	}

	const updateReInfoOrg = () => {
		form.validateFields().then(values => update({
			id                  : record.id,
			isUsePossibleRegion : values.isUsePossibleRegion,
			prices              : values.priceOrders ?? [],
			type                : values.type
		}))
	}

	return (
		<Modal
			className="orgs-add-modal"
			footer={ [
				<CustomButton
					key="submit"
					htmlType="submit"
					loading={ isSending }
					onClick={ () => updateReInfoOrg() }
				>
					Сохранить
				</CustomButton>
			] }
			title="Обновление сведений об организации"
			visible={ visible }
			width={ 800 }
			onCancel={ handleCancel }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 500 }
			>
				<Form
					labelWrap
					form={ form }
					labelCol={ { span: 7 } }
					layout="horizontal"
					style={ { width: "99%" } }
				>
					<Form.Item
						label="Организация"
						name="reOrg"
					>
						<Input.TextArea
							autoSize
							readOnly
						/>
					</Form.Item>
					<Form.Item
						label="Категория"
						name="type"
					>
						<CustomSelect
							allowClear
							showSearch
							mode="single"
							notFoundContent={ null }
							optionFilterProp="title"
							placeholder="Выберите категорию организации"
							style={ {
								width: '100%'
							} }
						>
							{ Boolean(types) && Array.isArray(types) && types?.map(type => {
								return (
									<Option
										key={ type.id }
										title={ type.name }
										value={ type.id }
									>
										{ type.name }
									</Option>)
							}) }
						</CustomSelect>
					</Form.Item>
					<Form.Item
						label="Использование возможных регионов реализации"
						name="isUsePossibleRegion"
						valuePropName="checked"
					>
						<Checkbox />
					</Form.Item>
					<Form.Item
						label="Порядок формирования цены"
						name="priceOrders"
						rules={ [
							{
								required : true,
								message  : "Пожалуйста, выберите порядок формирования цены"
							}
						] }
					>
						<CustomSelect
							allowClear
							showSearch
							mode="multiple"
							optionFilterProp="title"
							placeholder="Выберите порядки формирования цен"
							style={ {
								width: '100%'
							} }
						>
							{ Array.isArray(prices) && prices?.map(price => {
								return (
									<Option
										key={ price.id }
										title={ price.name }
										value={ price.id }
									>
										{ price.name }
									</Option>)
							}) }
						</CustomSelect>
					</Form.Item>
				</Form>
			</Scrollbars>
		</Modal>
	)
}

export default ChangeReInfoOrg